import { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";

import { fetchWithToken } from "helpers/fetch";
import { endPoints } from "const/endPoints";
import Spinner from "components/common/Spinner";

export const Question = ({ question, setResponses, responses }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);

  const getOptions = async () => {
    try {
      const response = await fetchWithToken(
        `${endPoints.get_all_options_by_question}/${question.id}`
      );

      if (response.status !== 200) {
        console.error("Error fetching options:", response.status);
        return;
      }

      const data = await response.json();
      console.log(`Options for question ${question.id}:`, data);
      setOptions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching options:", error);
      setOptions([]);
    }
  };

  useEffect(() => {
    if (question?.id) {
      getOptions();
    }
  }, [question]);

  const getResponses = (option, questionId) => {
    // Reemplazar la respuesta en su posicion original. Antes se filtraba la
    // pregunta y se volvia a agregar al final, con lo que el array quedaba
    // ordenado por el orden en que el alumno contestaba y no por el de las
    // preguntas. La forma funcional evita ademas trabajar sobre un `responses`
    // desactualizado al hacer clics rapidos.
    setResponses((prev) =>
      prev.map((response) =>
        response.questionId === questionId ? { questionId, option } : response
      )
    );
  };

  useEffect(() => {
    const filterResponses = responses?.find(
      (response) => response.questionId === question.id
    );
    if (filterResponses) {
      setSelected(filterResponses.option.id);
    }
  }, [responses]);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: { xs: "1.5rem 0", sm: "2rem 0" },
        borderRadius: { xs: "20px", sm: "35px" },
        width: "100%",
        margin: "2rem 0",
        transition: "all 0.5s ease-in-out",
        "&:hover": {
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "1.1rem", sm: "1.5rem", md: "2rem" },
          color: "#7f7f7f",
          textAlign: "center",
          marginBottom: { xs: "1rem", sm: "2rem" },
          padding: { xs: "0 1rem", sm: "0 2rem" },
        }}
      >
        {question.question}
      </Typography>
      <form>
        <Box>
          {options.length > 0 ? (
            options.map((option) => (
              <Box
                key={option.id}
                sx={{
                  padding: { xs: "0.8rem 1.5rem", sm: "1rem 3rem", md: "1rem 5rem" },
                  backgroundColor:
                    selected === option.id ? "rgb(74 149 191 / 75%)" : "#fff",
                  transition: "all 0.2s ease-in-out",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor:
                      selected === option.id
                        ? "rgb(74 149 191 / 75%)"
                        : "#f5f5f5",
                  },
                }}
                onClick={() => getResponses(option, question.id)}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "0.95rem", sm: "1.2rem" },
                    color: selected === option.id ? "#fff" : "#7f7f7f",
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  {option.title}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography sx={{ textAlign: "center", color: "#7f7f7f" }}>
              Loading options...
            </Typography>
          )}
        </Box>
      </form>
    </Box>
  );
};
